// The limits the API puts on a trial's fields (TrialController::fieldLimits), for the forms: text no
// longer than its column, no negative numbers and a real year.

export const TRIAL_MAX_LENGTH = {
  trialno: 100,
  pitxt: 50,
  subcontractor: 50,
  testitem: 50,
  locationtarget: 50,
  TrialAddress: 100,
  LocalReference: 50,
  EarthSample: 20,
  PosGPSLatitude: 10,
  PosGPSLongitude: 10,
};

/**
 * The longest text a diary entry's fields take, wherever they are edited (diary entry, Set time
 * interval, Complete task, Cancel task, mass complete) - the API's Diary::MAX_LENGTH.
 */
export const DIARY_MAX_LENGTH = {
  task: 1000,
  description: 2000,
  bbch: 50,
  timeinterval: 100,
  timeinterval_text: 100,
  planned_interval: 100,
  cancelled_reason: 2000,
};

export const TRIAL_YEAR_MIN = 2000;
export const TRIAL_YEAR_MAX = 2100;

// The months the Field Phase date pickers offer: past dates are allowed, and trials are planned
// up to 5 years ahead
export const FIELD_PHASE_YEARS_AHEAD = 5;
export const FIELD_PHASE_START_MONTH = new Date(TRIAL_YEAR_MIN, 0, 1);
export const FIELD_PHASE_END_MONTH = new Date(new Date().getFullYear() + FIELD_PHASE_YEARS_AHEAD, 11, 31);

// A number input still accepts "e" (exponent), "+" and "-"; none belong in these fields
export function blockNonDigitKeys(e) {
  if (['e', 'E', '+', '-'].includes(e.key)) e.preventDefault();
}

/** Props for a number input that takes no negative numbers. */
export const NON_NEGATIVE_NUMBER = { min: 0, onKeyDown: blockNonDigitKeys };

/** Props for the Year input. */
export const YEAR_NUMBER = { min: TRIAL_YEAR_MIN, max: TRIAL_YEAR_MAX, onKeyDown: blockNonDigitKeys };
